/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Hydraulic_CoilsInputs */



/**
* | output |
* | --- |
* | "Hydraulic coils" |
*
* @param {Air_Handler_Unit_Hydraulic_CoilsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_hydraulic_coils = /** @type {((inputs?: Air_Handler_Unit_Hydraulic_CoilsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Hydraulic_CoilsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Hydraulic coils")
	return /** @type {LocalizedString} */ ("Batteries hydrauliques")
});